import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import ConnectWallet from './components/ConnectWallet';
import CreateOfferForm from './components/CreateOfferForm';
import OffersTable from './components/OffersTable';
import BalanceCard from './components/BalanceCard';
import { CONTRACT_ADDRESS, CONTRACT_ABI } from './constants';
import './App.css';

function App() {
  const [provider, setProvider] = useState(null);
  const [signer, setSigner] = useState(null);
  const [contract, setContract] = useState(null);
  const [account, setAccount] = useState(null);
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    if (contract) {
      fetchOffers();
    }
  }, [contract]);

  const fetchOffers = async () => {
    try {
      const fetchedOffers = [];
      let i = 0;
      while (true) {
        try {
          const offer = await contract.offers(i);
          fetchedOffers.push({ ...offer, index: i });
          i++;
        } catch (error) {
          // We've reached the end of the offers array
          break;
        }
      }
      console.log("Number of offers fetched:", fetchedOffers.length);
      setOffers(fetchedOffers);
    } catch (error) {
      console.error('Error fetching offers:', error);
    }
  };

  return (
    <div className="App">
      <nav className="navbar">
        <h1>LiquiMarkets</h1>
        <div>
          <ConnectWallet
            setProvider={setProvider}
            setSigner={setSigner}
            setContract={setContract}
            setAccount={setAccount}
            account={account}
          />
        </div>
      </nav>
      <div className="content">
        <div className="column">
          <CreateOfferForm contract={contract} signer={signer} fetchOffers={fetchOffers} />
          {account && <BalanceCard contract={contract} account={account} />}
        </div>
        <div className="column">
          <OffersTable 
            offers={offers} 
            contract={contract} 
            signer={signer} 
            fetchOffers={fetchOffers} 
            account={account}
          />
        </div>
      </div>
    </div>
  );
}

export default App;